import type { LevelData, PuzzleDefinition, PuzzleData } from '../types';

/** Slice a sub-puzzle's solution from the level's full solution grid. */
export function sliceSolution(
  solution: boolean[][],
  puzzle: PuzzleDefinition,
): boolean[][] {
  const result: boolean[][] = [];
  for (let r = 0; r < puzzle.height; r++) {
    const row = solution[puzzle.row + r];
    result.push(row ? row.slice(puzzle.col, puzzle.col + puzzle.width) : []);
  }
  return result;
}

/** Resolve a sub-puzzle into a playable puzzle with its solution slice. */
export function resolvePuzzle(
  level: LevelData,
  puzzleIndex: number,
): PuzzleData {
  const puzzle = level.puzzles[puzzleIndex];
  return {
    width: puzzle.width,
    height: puzzle.height,
    difficulty: puzzle.difficulty,
    solution: sliceSolution(level.solution, puzzle),
  };
}

/** Get the full solution image (it's just level.solution now). */
export function assembleFullImage(level: LevelData): boolean[][] {
  return level.solution;
}

/** Count sub-puzzles that have no filled cells in the level solution. */
export function countEmptySubPuzzles(level: LevelData): number {
  let count = 0;
  for (const p of level.puzzles) {
    let hasFill = false;
    for (let r = 0; r < p.height && !hasFill; r++) {
      const row = level.solution[p.row + r];
      if (!row) continue;
      for (let c = 0; c < p.width; c++) {
        if (row[p.col + c]) {
          hasFill = true;
          break;
        }
      }
    }
    if (!hasFill) count++;
  }
  return count;
}
